import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'New course',
  subtitle:
    "Let's kick things off by adding some key details about your course!",
  titleTextPlaceholder: 'Give your course a name',
  titleTextTitle: 'Course name',
  subjectSelectTitle: 'Course category',
  subjectSelectPlaceholder: 'Select a category for this course',
  descriptionTextPlaceholder: 'Describe your course',
  descriptionTextTitle: 'Course description',
  iconPlaceholder: 'Upload a course icon',
  saveAndExit: 'Save and close',
  iconHeading: 'Course icon',
  type: 'Assessable course',
  publicListing: 'Allow public listing with self-enrollment',
  structureSelectPlaceholder: 'Select course structure',
  structureSelectTitle: 'Course structure',
  sizePlaceholder: 'Select number',
  nextStep: 'Next step',
  cancel: 'Cancel',
  wantGradable: 'Want assessable courses?',
  passingScore: 'Passing score',
};

const welsh = {
  title: 'Cwrs newydd',
  subtitle: 'Dechreuwch trwy ychwanegu rhai manylion allweddol am eich cwrs!',
  titleTextPlaceholder: "Rhowch enw i'ch cwrs",
  titleTextTitle: "Enw'r cwrs",
  subjectSelectTitle: "Categori'r cwrs",
  subjectSelectPlaceholder: 'Dewiswch gategori ar gyfer y cwrs hwn',
  descriptionTextPlaceholder: 'Disgrifiwch eich cwrs',
  descriptionTextTitle: 'Disgrifiad y cwrs',
  iconPlaceholder: 'Uwchlwythwch eicon y cwrs',
  saveAndExit: 'Cadw a chau',
  iconHeading: 'Eicon y cwrs',
  type: "Cwrs Sy'n Efallai i'w asesadwy",
  publicListing: 'Caniatewch rhestru cyhoeddus gyda chofrestru eich hun',
  structureSelectPlaceholder: 'Dewis strwythur y cwrs',
  structureSelectTitle: 'Strwythur y cwrs',
  sizePlaceholder: 'Dewis rhif',
  nextStep: 'Cam nesaf',
  cancel: 'Canslo',
  wantGradable: "Ydych chi eisiau cyrsiau sy'n efallai i'w asesadwy?",
  passingScore: "Sgôr i'r basio",
};

export const createCourseText: any = getLocalizationBasedOnLang(english, welsh);
